"use client";

import { useFormStatus } from "react-dom";

/** A submit button that disables itself and swaps its label while its own <form>
 *  posts. For server-rendered forms (sign in, sign out) that cannot hold pending
 *  state themselves: `useFormStatus` reads only the nearest enclosing form, so this
 *  has to be rendered inside it. */
export function PendingSubmit({ className, label, pendingLabel }: { className: string; label: string; pendingLabel: string }) {
  const { pending } = useFormStatus();
  return (
    <button type="submit" className={className} disabled={pending}>
      {pending ? pendingLabel : label}
    </button>
  );
}
